/**
 * Color Diversity for Product Grid
 * Enhances the color diversity system by providing additional functionality
 */

class ColorDiversityManager {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupColorDiversity());
    } else {
      this.setupColorDiversity();
    }
  }

  setupColorDiversity() {
    // Find all color diverse product grid items
    const colorDiverseItems = document.querySelectorAll('.color-diverse-item');
    
    if (colorDiverseItems.length === 0) return;

    // Add visual indicators for debugging (optional)
    this.addColorIndicators(colorDiverseItems);
    
    // Log color diversity information for debugging
    this.logColorDiversity(colorDiverseItems);
  }

  addColorIndicators(items) {
    // Add small color indicators to show which color palette was assigned
    // This is useful for debugging and can be removed in production
    items.forEach(item => {
      const targetColor = item.dataset.targetColor;
      if (targetColor) {
        // Add a small indicator to the product card
        const indicator = document.createElement('div');
        indicator.className = 'color-diversity-indicator';
        indicator.style.cssText = `
          position: absolute;
          top: 8px;
          right: 8px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: 2px solid white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2);
          z-index: 10;
          background-color: ${this.getColorForPalette(targetColor)};
        `;
        indicator.title = `Color palette: ${targetColor}`;
        
        const container = item.querySelector('.product-grid-item__container');
        if (container) {
          container.style.position = 'relative';
          container.appendChild(indicator);
        }
      }
    });
  }

  getColorForPalette(palette) {
    const colors = {
      warm: '#ff6b6b',
      cool: '#4ecdc4',
      bright: '#45b7d1',
      earth: '#96ceb4',
      neutral: '#f7f7f7'
    };
    return colors[palette] || '#cccccc';
  }

  logColorDiversity(items) {
    // Log information about the color diversity for debugging
    const colorCounts = {};
    items.forEach(item => {
      const color = item.dataset.targetColor;
      colorCounts[color] = (colorCounts[color] || 0) + 1;
    });
    
    console.log('Color Diversity Distribution:', colorCounts);
    
    // Check if we have good diversity
    const totalItems = items.length;
    const expectedPerColor = totalItems / 5; // 5 color palettes
    const diversity = Object.values(colorCounts).reduce((sum, count) => {
      return sum + Math.abs(count - expectedPerColor);
    }, 0);
    
    console.log(`Color diversity score: ${Math.round((1 - diversity / totalItems) * 100)}%`);
  }
}

// Initialize the color diversity manager
new ColorDiversityManager(); 